import React, { useEffect, useState } from "react";
import PoModification from "./poModification";
import _ from "lodash";
import { getSecPermission } from "../../constant";

const initialColumns = [
    { id: "itemno", label: "Item No", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "description", label: "Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "View_Description" },
    { id: "hsn/saccode", label: "HSN/SAC Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "purchaserequisition", label: "Purchase Requisition", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "uom", label: "UOM", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "quantity", label: "Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "rate(in inr)", label: "Rate (in INR)", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "amount(in inr)", label: "Amount (in INR)", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  ];

  const permissionInit = {
    create: false,
    read: false,
    update: false,
    delete: false,
  };

function PoModificationDetail() {
   
  const [secPORequestPermission, setSecPORequestPermission] = useState({
    "PO_REQUEST_LISTING": permissionInit,
    "CREATE_QUANTITY_MOD_REQ": permissionInit,
    "CREATE_PRICE_MOD_REQ": permissionInit,
    "PO_REQUEST_DETAILS": permissionInit,
    "APPROVE_PO_REQUEST": permissionInit,
    "REJECT_PO_REQUEST": permissionInit,
    "ASSIGN_PO_REQUEST": permissionInit,
    "SUBMIT_PO_REQUEST": permissionInit,
  });
  
  useEffect(() => {
    let secPORequestPermissionInit = _.cloneDeep(secPORequestPermission);
    let obj = {};
    for (let key in secPORequestPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecPORequestPermission(obj);
    // getSummary("?uniqueName=LORRY_RECEIPT");

  }, []);

  return (
   <>
       <PoModification 
        initialColumns={initialColumns}
        secName="Details"
        lineItemName="lineItems"
        additionalData={{
          type: "PO Modification Request",
          is_APPROVE: secPORequestPermission?.APPROVE_PO_REQUEST?.read,
          is_REJECT: secPORequestPermission?.REJECT_PO_REQUEST?.read,
          is_ASSIGN: secPORequestPermission?.ASSIGN_PO_REQUEST?.read,
        }}
       />
   </>
  )
}

export default PoModificationDetail